<template>
  <div class="min-h-screen flex items-center justify-center p-4 bg-slate-50 dark:bg-slate-900">
    <div class="max-w-md w-full bg-white dark:bg-slate-800 rounded-3xl p-8 text-center shadow-xl border border-slate-200 dark:border-slate-700">
      <div class="w-20 h-20 bg-amber-100 dark:bg-amber-900/30 rounded-full flex items-center justify-center mx-auto mb-6">
        <XCircle class="w-10 h-10 text-amber-500" />
      </div>

      <h1 class="text-2xl font-bold text-slate-900 dark:text-white mb-2">Pago Cancelado</h1>
      <p class="text-slate-500 dark:text-slate-400 mb-8 text-sm">
        Has cancelado el proceso de pago. Tu factura sigue pendiente en tu panel y puedes intentarlo de nuevo cuando desees.
      </p>

      <router-link
        to="/client/billing"
        class="inline-flex items-center justify-center w-full py-3 px-4 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 font-bold transition-all"
      >
        Volver a Facturación
      </router-link>
    </div>
  </div>
</template>

<script setup>
import { XCircle } from 'lucide-vue-next';
</script>